export function getUrlLocale(location: Location = window.location): string | undefined {
  const fromSearch = new URLSearchParams(location.search).get('locale');
  if (fromSearch) return fromSearch;

  const hash = location.hash;
  const queryStart = hash.indexOf('?');
  if (queryStart === -1) return undefined;

  return new URLSearchParams(hash.slice(queryStart + 1)).get('locale') ?? undefined;
}
